import "dayjs/locale/ja";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/types";
import { useSearchVouchersMutation } from "../../../services/voucher";
import { useEffect } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import ROUTES from "../../../routes";

const VoucherRegister = () => {
  const { loggedInUser } = useSelector((state: RootState) => state.global);
  const companyId = loggedInUser?.currentCompany?.id;
  const [searchVouchers, searchVouchersResult] = useSearchVouchersMutation();

  useEffect(() => {
    searchVouchers({ companyId, body: {} }).unwrap();
  }, [companyId])
  return (
    <div className="vouchers-register ant-table-content">
      <h2>Vouchers</h2>
      <table style={{ tableLayout: "auto" }}>
        <thead className="ant-table-thead">
          <tr>
            <th>Date</th><th>Voucher No.</th><th>Voucher Type</th><th>Account No.</th><th>Account Title</th><th>Debit</th><th>Credit</th>
          </tr>
        </thead>
        <tbody className="ant-table-tbody">
          {
            searchVouchersResult.isSuccess && searchVouchersResult.data.map((row: any) => (
              row.transAccounts.map((ta: any, index: number) => (
                <tr className="ant-table-row ant-table-row-level-0" key={ta.id}>
                  {index === 0 && <>
                    <td rowSpan={row.transAccounts.length} className="ant-table-cell" style={{ verticalAlign: "top" }}>
                      {dayjs(row.transTime).format("DD/MM/YYYY")}
                    </td>
                    <td rowSpan={row.transAccounts.length} className="ant-table-cell" style={{ verticalAlign: "top" }}>
                      <Link to={`${ROUTES.PATHS.CREDIT_VOUCHER_MENU}/${row.id}`} > {row.voucherNo}</Link>
                    </td>
                    <td rowSpan={row.transAccounts.length} className="ant-table-cell" style={{ verticalAlign: "top" }}>
                      {row.voucherType?.name}
                    </td>
                  </>}
                  <td className="ant-table-cell">
                    {ta.account?.accountNo}
                  </td>
                  <td className="ant-table-cell">
                    {ta.account?.accountTitle}
                  </td>
                  <td className="ant-table-cell text-right">
                    {ta.debitAmount}
                  </td>
                  <td className="ant-table-cell text-right">
                    {ta.creditAmount}
                  </td>
                </tr>
              ))
            ))
          }
        </tbody>
      </table>
    </div>
  );
};

export default VoucherRegister;
